import { Button, useDeviceType } from '@cian/ui-kit';
import * as style from './RentFastNSave.css';
import { clsx } from 'clsx';
import { clickOpenModal } from '../tracking';
import { useApplicationContext } from 'shared/utils/applicationContext';

interface IRentFastNSaveProps {
  onChangeModalVisible: VoidFunction;
}

export const RentFastNSave: React.FC<IRentFastNSaveProps> = ({ onChangeModalVisible }) => {
  const device = useDeviceType();

  const {
    custom: { userId },
  } = useApplicationContext();

  const handleOpenModal = () => {
    onChangeModalVisible();
    clickOpenModal('submitApplication', userId);
  };

  return (
    <div
      className={clsx(
        style['container'],
        device === 'tablet' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['text-block']}>
        <h1 className={style['title']}>Сдайте квартиру быстро и безопасно</h1>
        <div className={style['subtitle']}>Без забот и без хлопот</div>
      </div>
      <div className={style['btn-container']}>
        <Button size="L" fullWidth onClick={handleOpenModal}>
          Оставить заявку
        </Button>
      </div>
    </div>
  );
};
